export default function NotFound() {
    return (
        <div className="container d-flex flex-column align-items-center justify-content-center text-center" style={{ minHeight: "80vh" }}>
            <h1 className="display-3 fw-bold mb-3 text-primary">404</h1>
            <h2 className="mb-4">Page Not Found</h2>
            <p className="lead mb-4">Oops! The page you’re looking for doesn’t exist or has been moved.</p>
        </div>
    );
}
